import IndexPage from '../components/IndexPage';

export default IndexPage;
